import * as React from 'react';

const caseStudiesIconSmall = (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="4" fill="white"/>
    <path d="M16.6426 18H3.35743C2.60774 18 2 17.3923 2 16.6426V10L10 12.4L18 10V16.6426C18 17.3923 17.3923 18 16.6426 18Z" fill="url(#paint0_linear_23111_833)"/>
    <path d="M14.0043 5.2C14.0019 5.2 14 5.19807 14 5.19569V3.35743C14 2.60774 13.3922 2 12.6426 2H7.35741C6.60772 2 5.99998 2.60774 5.99998 3.35743V5.19569C5.99998 5.19807 5.99805 5.2 5.99567 5.2H3.35743C2.60774 5.2 2 5.80774 2 6.55743V8.39679C2 8.3987 2.00125 8.40037 2.00307 8.40092L9.99876 10.7996C9.99957 10.7999 10.0004 10.7999 10.0012 10.7996L17.9969 8.40092C17.9988 8.40037 18 8.3987 18 8.39679V6.55743C18 5.80774 17.3923 5.2 16.6426 5.2H14.0043ZM7.60429 5.2C7.60191 5.2 7.59998 5.19807 7.59998 5.19569V3.60431C7.59998 3.60193 7.60191 3.6 7.60429 3.6H12.3957C12.398 3.6 12.4 3.60193 12.4 3.60431V5.19569C12.4 5.19807 12.398 5.2 12.3957 5.2H7.60429Z" fill="url(#paint1_linear_23111_833)"/>
    <defs>
    <linearGradient id="paint0_linear_23111_833" x1="15.4815" y1="16.7059" x2="0.940106" y2="5.93591" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint1_linear_23111_833" x1="13.7647" y1="8.49524" x2="0.974509" y2="-5.6161" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BDD1E7"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    </defs>
    </svg>    
    );

export default caseStudiesIconSmall; 
